import styled from 'styled-components';

const HeroBuildingStyle = styled.div`
	--circleSize: var(--sp8x);
	--circlePadLR: var(--sp2x);
	--circlePadTB: var(--sp1-5x);
	--padIndividualTB: var(--sp3x);
	--padIndividualLR: var(--sp3x);
	--radiusIndividual: var(--sp2-5x);
	--leftSizeDistance: var(--sp1-5x);
	--individualGapDistance: var(--sp1-5x);

	position: relative;
	margin-bottom: var(--sectionDistance);
	min-height: calc((1300 / 2560) * 100vw);

	.wrapper-navigation {
		position: absolute;
		bottom: 0;
		left: 0;
	}

	.layer-item {
		rect,
		polygon,
		polyline,
		path {
			opacity: 0;
			fill: var(--green1000);
			transition: all var(--trTime) ease-out;
		}
	}

	.container-in-svg-info {
		display: flex;
		align-items: center;
		justify-content: center;
		transition: all var(--trTime) ease-out;
		height: 100%;
		position: relative;
	}

	.every-item-floor {
		pointer-events: none;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: var(--trTime) ease-out;
		opacity: 0;
		z-index: 20;

		&.active {
			opacity: 1;
			.text-info-wrapper {
				.wrapper-info-individual-floor {
					transform: scale(1);
				}
			}
		}

		.text-info-wrapper {
            width: var(--circleSize);
            height: var(--circleSize);
			color: var(--white);
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;

			.text-info {
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: var(--black1000);
                width: var(--circleSize);
                height: var(--circleSize);
                border-radius: 100%;
                padding: var(--circlePadTB) var(--circlePadLR);
			}

			.wrapper-info-individual-floor {
				position: absolute;
				color: var(--black1000);
				background-color: var(--white);
				left: calc(100% + var(--leftSizeDistance));
				bottom: 0;
				white-space: nowrap;
				padding: var(--padIndividualTB) var(--padIndividualLR);
				border-radius: var(--radiusIndividual);
				transform: scale(0);
				transition: var(--trTime) ease-out;
				transform-origin: left bottom;
				will-change: transform;
				display: flex;
				flex-direction: column;
				gap: var(--individualGapDistance);
			}

            .wrapper-select-floor-to-view {
                position: absolute;
                left: calc(100% + var(--leftSizeDistance));
                width: 175px;
            }
		}
	}

	.wrapper-info-building {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		right: var(--contPaddingLR);
	}

	.layer-item {
		&.available {
			.container-in-svg-info {
				opacity: 1;
			}

			rect,
			polygon,
			polyline,
			path {
				opacity: 0.5;
				fill: var(--green1000);
				cursor: pointer;
			}
		}
	}

	.item-reverse {
		.text-info-wrapper {
			.wrapper-info-individual-floor {
				transform-origin: top left !important;
				top: 0;
				height: fit-content;
			}
		}
	}

    @keyframes wobble {
        0% {
            transform: translateX(0%);
        }
        15% {
            transform: translateX(-25%) rotate(-5deg);
        }
        30% {
            transform: translateX(20%) rotate(3deg);
        }
        45% {
            transform: translateX(-15%) rotate(-3deg);
        }
        60% {
            transform: translateX(10%) rotate(2deg);
        }
        75% {
            transform: translateX(-5%) rotate(-1deg);
        }
        100% {
            transform: translateX(0%);
        }
    }

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--circleSize: var(--sp6x);
		--circlePadLR: var(--sp2x);
		--circlePadTB: calc(var(--sp1-5x) - var(--sp0-5x) / 2);
		--padIndividualTB: var(--sp3x);
		--padIndividualLR: var(--sp3x);
		--radiusIndividual: var(--sp2-5x);
		--leftSizeDistance: var(--sp1-5x);
		--individualGapDistance: var(--sp1-5x);
	}
	/* //! 1510 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--circleSize: var(--sp5x);
		--circlePadLR: var(--sp1-5x);
		--circlePadTB: var(--sp1x);
		--padIndividualTB: var(--sp3x);
		--padIndividualLR: var(--sp3x);
		--radiusIndividual: var(--sp2-5x);
		--leftSizeDistance: var(--sp1x);
		--individualGapDistance: var(--sp1-5x);

		min-height: 55.8vw;

		.wrapper-svg {
			svg {
				height: 55.8vw;
			}
		}
	}
	/* //! 1440 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--circleSize: var(--sp5x);
		--circlePadTB: var(--sp1x);
		--circlePadLR: var(--sp1-5x);
		--padIndividualTB: var(--sp3x);
		--padIndividualLR: var(--sp3x);
		--radiusIndividual: var(--sp2-5x);
		--leftSizeDistance: var(--sp1x);
		--individualGapDistance: var(--sp1-5x);

		min-height: 52.3vw;

		.wrapper-svg {
			svg {
				height: 52.3vw;
			}
		}
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--circleSize: var(--sp5x);
		--circlePadTB: var(--sp1x);
		--circlePadLR: var(--sp1-5x);
		--padIndividualTB: var(--sp2x);
		--padIndividualLR: var(--sp2x);
		--radiusIndividual: var(--sp2-5x);
		--leftSizeDistance: var(--sp1x);
		--individualGapDistance: var(--sp1-5x);

		min-height: 58.8vw;

		.wrapper-svg {
			svg {
				height: 58.8vw;
			}
		}
	}
	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--circleSize: var(--sp5x);
		--circlePadTB: var(--sp2x);
		--circlePadLR: var(--sp1-5x);
		--padIndividualTB: var(--sp2x);
		--padIndividualLR: var(--sp2x);
		--radiusIndividual: var(--sp2-5x);
		--leftSizeDistance: var(--sp1x);
		--individualGapDistance: var(--sp1-5x);

		min-height: 74.1vw;

		.wrapper-svg {
			svg {
				height: 74.1vw;
			}
		}
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--circleSize: var(--sp5x);
		--circlePadTB: var(--sp1x);
		--circlePadLR: var(--sp1-5x);
		--padIndividualTB: var(--sp2x);
		--padIndividualLR: var(--sp2x);
		--radiusIndividual: var(--sp2-5x);
		--leftSizeDistance: var(--sp1x);
		--individualGapDistance: var(--sp1-5x);

		min-height: 98.8vw;

		.wrapper-svg {
			transform: translateX(-20%);
			svg {
				height: 98.8vw;
			}
		}

		.every-item-floor {
			justify-content: flex-start;
			padding-left: var(--sp8x);

			.text-info-wrapper {
				.wrapper-info-individual-floor {
					bottom: calc(var(--circleSize) - 190%);
					transform-origin: left center;
				}
			}
		}

		&.building-z {
			.wrapper-svg {
				transform: translateX(-32%);
			}
		}
	}
	/* //! 414 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--circleSize: var(--sp5x);
		--circlePadTB: var(--sp1x);
		--circlePadLR: var(--sp1-5x);
		--padIndividualTB: var(--sp2x);
		--padIndividualLR: var(--sp2x);
		--radiusIndividual: var(--sp2-5x);
		--leftSizeDistance: var(--sp1x);
		--individualGapDistance: var(--sp1x);

		min-height: 100vw;

        .text-info {
            animation: wobble 2s ease infinite;
        }

		.every-item-floor {
			justify-content: flex-start;
			padding-left: var(--sp2x);

			.text-info-wrapper {
				.wrapper-info-individual-floor {
					bottom: calc(var(--circleSize) - 170%);
					transform-origin: left center;
				}
			}
		}

		.wrapper-svg {
			transform: translateX(-31%);

			svg {
				height: 110vw;
			}
		}

		&.building-z {
			.wrapper-svg {
				transform: translateX(-41%);
			}
		}

		.wrapper-navigation {
			position: relative;
			bottom: 0;
			left: 0;
		}
	}
`;
export default HeroBuildingStyle;
